.avatar {
  border-radius: 3px;
  box-shadow: 0 0 1px rgb(0 0 0 / 25%);
  height: var(--icon-size-sm);
  margin-right: 5px;
  width: var(--icon-size-sm);
}

.emptyAvatar {
  composes: avatar;
  align-items: center;
  background-color: var(--color-bg-subtle);
  color: var(--color-text-subtle);
  display: flex;
  justify-content: center;
}

.text {
  box-sizing: border-box;
  color: var(--color-text-neutral);
  cursor: pointer;
  flex: 1;
  font-size: 12px;
  position: relative;
  text-align: left;
}

.name {
  font-size: 12px;
  font-weight: 600;
}
